import { CloudMarketplace } from '../../../modules/productsListing/types'
import {
  awsBuyerItemsToRender,
  awsContractItemsToRender,
  awsDisbursementItemsToRender,
  awsOfferItemsToRender,
  awsRevenueItemsToRender,
  azureBuyerItemsToRender,
  azureContractItemsToRender,
  azureDisbursementItemsToRender,
  azureOfferItemsToRender,
  azureRevenueItemsToRender,
  gcpBuyerItemsToRender,
  gcpContractItemsToRender,
  gcpDisbursementItemsToRender,
  gcpOfferItemsToRender,
  gcpRevenueItemsToRender,
  ObjectWithReportRowValues,
} from './RevenueInsightsComponentMap'

export type RevenueInsightsDetailSection =
  | 'buyer'
  | 'offer'
  | 'contract'
  | 'disbursement'
  | 'revenue'

const revenueInsightsSectionMap: Record<
  CloudMarketplace,
  Record<RevenueInsightsDetailSection, ObjectWithReportRowValues>
> = {
  AWS: {
    buyer: awsBuyerItemsToRender,
    offer: awsOfferItemsToRender,
    contract: awsContractItemsToRender,
    disbursement: awsDisbursementItemsToRender,
    revenue: awsRevenueItemsToRender,
  },
  AZURE: {
    buyer: azureBuyerItemsToRender,
    offer: azureOfferItemsToRender,
    contract: azureContractItemsToRender,
    disbursement: azureDisbursementItemsToRender,
    revenue: azureRevenueItemsToRender,
  },
  GCP: {
    buyer: gcpBuyerItemsToRender,
    offer: gcpOfferItemsToRender,
    contract: gcpContractItemsToRender,
    disbursement: gcpDisbursementItemsToRender,
    revenue: gcpRevenueItemsToRender,
  },
  REDHAT: {
    buyer: awsBuyerItemsToRender,
    offer: awsOfferItemsToRender,
    contract: awsContractItemsToRender,
    disbursement: awsDisbursementItemsToRender,
    revenue: awsRevenueItemsToRender,
  },
}

export const getRevenueInsightsItemsByCloud = (
  cloud: CloudMarketplace,
  section: RevenueInsightsDetailSection
): ObjectWithReportRowValues => revenueInsightsSectionMap[cloud][section]
